export default __webpack_public_path__ + "img/7e58e284edc5396d84dac8c0c1bb0297.png";